export default {
    setCustomers(state, payload){
        state.customers = payload;
    },

    setPages(state, payload){
        state.pages = payload;
    }
}